import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
    name: 'listDate',
    standalone: true,
})
export class ListDatePipe implements PipeTransform {
    transform(value: string): string {
        if (!value) return value;

        return moment(value).format('YYYY-MM-DD');
    }
}
